import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

function Redirect() {
  const [params] = useSearchParams();
  const to = params.get('to');

  const sanitizedTo = useMemo(() => {
    if (!to) {
      return '/'; // Default to home if no URL provided
    }

    try {
      const url = new URL(to, window.location.origin);

      // Only allow redirects to the same origin or explicitly allowed domains
      const allowedDomains = [
        'carvana.com',
        'youtube.com',
        'youtu.be',
        'google.com',
        window.location.hostname,
        // Add other trusted domains here
      ];

      const isAllowedDomain = allowedDomains.some(
        (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
      );

      if (!isAllowedDomain) {
        console.warn('Redirect attempted to unauthorized domain:', url.hostname);
        return '/';
      }

      // Remove any potentially dangerous URL parameters
      const safeUrl = new URL(url.pathname + url.search, url.origin);
      return safeUrl.toString();
    } catch (error) {
      console.error('Invalid redirect URL:', error);
      return '/';
    }
  }, [to]);

  useEffect(() => {
    setTimeout(() => {
      window.location.href = sanitizedTo;
    }, 4000);
  }, [sanitizedTo]);

  return (
    <div style={{ color: 'black', margin: '20px' }}>
      You'll be redirected to <a href={sanitizedTo}>{sanitizedTo}</a> shortly.
    </div>
  );
}

export default Redirect;
